<template>
  <bscroll-view ref="readingRoomListBScrollView">
    <div class="reading-room-list">
      <div class="main-content-wrap">
        <div v-if="currentResType.type === 1" class="carousel-wrap">
          <el-carousel
            :interval="40000"
            type="card"
            height="260px"
            indicator-position="none"
          >
            <el-carousel-item
              v-for="(item, index) in currentRecommendData.slice(0, 12)"
              :key="index"
            >
              <div class="swiper-content">
                <div class="hb-resource-cover lr-magazine-cover">
                  <img :src="item.poster" />
                </div>
                <div class="infos">
                  <div class="name text1line">
                    {{ langTransfer(item.name) }}
                  </div>
                  <div class="update">
                    {{ langTransfer("更新至:") }}
                    <span>
                      {{
                        langTransfer(
                          `${item.year}年${("0" + item.issue).substr(-2)}期`
                        )
                      }}</span
                    >
                  </div>
                  <div class="summary text2line">
                    {{ langTransfer(item.introduction) }}
                  </div>
                  <button @click.stop="detailDispatcher('magazine', item, 1)">
                    {{ langTransfer("查看详情") }}
                  </button>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div
          v-if="currentUpdateData && currentUpdateData.length > 0"
          class="lasted-update-wrap"
        >
          <div class="common-cut-header">
            <h5 v-if="paginate.total > 0" class="sums">
              {{ langTransfer("最近更新") }}
            </h5>
          </div>
          <div v-if="currentResType.type === 1" class="list-wrap">
            <div
              v-for="(item, index) in currentUpdateData"
              :key="item.id"
              class="item"
              @click="detailDispatcher('magazine', item, 1)"
            >
              <div
                class="hb-resource-cover lr-img-scale lr-high-light lr-magazine-cover"
              >
                <img :src="item.poster" />
              </div>
              <div class="index-num">
                {{ `0${index + 1}`.substr(-2) }}
              </div>
              <div class="infos">
                <p class="name text1line">
                  {{ langTransfer(item.name) }}
                </p>
                <p class="year-issue text1line">
                  {{
                    langTransfer(
                      `${item.year}年${("0" + item.issue).substr(-2)}期`
                    )
                  }}
                </p>
              </div>
            </div>
            <div class="item hb-spacebeteen-empty" />
            <div class="item hb-spacebeteen-empty" />
          </div>
          <div v-if="currentResType.type === 3" class="list-wrap book-list">
            <div
              v-for="(item, index) in currentUpdateData.slice(0, 9)"
              :key="item.id"
              class="item"
              @click="detailDispatcher('book', item)"
            >
              <div
                class="hb-resource-cover lr-img-scale lr-high-light lr-book-cover"
              >
                <img :src="item.poster" />
              </div>
              <div class="index-num">
                {{ `0${index + 1}`.substr(-2) }}
              </div>
              <div class="infos">
                <p class="name text1line">
                  {{ langTransfer(item.name) }}
                </p>
              </div>
            </div>
            <div class="item hb-spacebeteen-empty" />
          </div>
          <div v-if="currentResType.type === 15" class="list-wrap book-list">
            <div
              v-for="(item, index) in currentUpdateData.slice(0, 9)"
              :key="item.id"
              class="item"
              @click="detailDispatcher('assemblyBook', item)"
            >
              <div
                class="hb-resource-cover lr-img-scale lr-high-light lr-book-cover"
              >
                <img :src="item.poster" />
              </div>
              <div class="index-num">
                {{ `0${index + 1}`.substr(-2) }}
              </div>
              <div class="infos">
                <p class="name text1line">
                  {{ langTransfer(item.name) }}
                </p>
              </div>
            </div>
            <div class="item hb-spacebeteen-empty" />
          </div>
          <div v-if="currentResType.type === 4" class="list-wrap audio-list">
            <div
              v-for="(item, index) in currentUpdateData.slice(0, 12)"
              :key="item.id"
              class="item"
              @click="detailDispatcher('audio', item)"
            >
              <div class="hb-resource-cover lr-img-scale">
                <img :src="item.poster" />
              </div>
              <div class="infos">
                <p class="index-num text1line">
                  {{ `0${index + 1}`.substr(-2) }}
                </p>
                <p class="name text1line">
                  {{ langTransfer(item.name) }}
                </p>
              </div>
              <img class="play-icon" src="@/assets/img/play-black.png" />
            </div>
            <div class="item hb-spacebeteen-empty" />
            <div class="item hb-spacebeteen-empty" />
          </div>
          <div v-if="currentResType.type === 5" class="list-wrap video-list">
            <div
              v-for="(item, index) in currentUpdateData.slice(0, 12)"
              :key="item.id"
              class="item"
              @click="detailDispatcher('video', item)"
            >
              <div class="hb-resource-cover lr-img-scale">
                <img :src="item.poster" />
              </div>
              <div class="infos">
                <p class="index-num text1line">
                  {{ `0${index + 1}`.substr(-2) }}
                </p>
                <p class="name text1line">
                  {{ langTransfer(item.name) }}
                </p>
              </div>
            </div>
            <div class="item hb-spacebeteen-empty" />
            <div class="item hb-spacebeteen-empty" />
          </div>
        </div>
        <div class="total-list-wrap">
          <div class="header">
            <h5>
              {{ langTransfer(currentResType.text) }}
            </h5>
            <!-- <p v-if="paginate.total > 0" class="sums-num">
              {{ langTransfer(`${paginate.total}种`) }}
            </p> -->
          </div>
          <div v-if="currentResType.type === 1" class="list-wrap">
            <div
              v-for="item in listData"
              :key="item.id"
              class="item"
              @click="detailDispatcher('magazine', item, 1)"
            >
              <div
                class="hb-resource-cover lr-img-scale lr-high-light lr-magazine-cover"
              >
                <img :src="item.poster" />
              </div>
              <p class="name text1line">
                {{ langTransfer(item.name) }}
              </p>
              <p class="year-issue">
                {{
                  langTransfer(
                    `${item.year}年${("0" + item.issue).substr(-2)}期`
                  )
                }}
              </p>
            </div>
          </div>
          <div v-if="currentResType.type === 3" class="list-wrap book-list">
            <div
              v-for="item in listData"
              :key="item.id"
              class="item"
              @click="detailDispatcher('book', item)"
            >
              <div
                class="hb-resource-cover lr-img-scale lr-high-light lr-book-cover"
              >
                <img :src="item.poster" />
              </div>
              <p class="name text1line">
                {{ langTransfer(item.name) }}
              </p>
            </div>
          </div>
          <div v-if="currentResType.type === 15" class="list-wrap book-list">
            <div
              v-for="item in listData"
              :key="item.id"
              class="item"
              @click="detailDispatcher('assemblyBook', item)"
            >
              <div
                class="hb-resource-cover lr-img-scale lr-high-light lr-book-cover"
              >
                <img :src="item.poster" />
              </div>
              <p class="name text1line">
                {{ langTransfer(item.name) }}
              </p>
            </div>
          </div>
          <div v-if="currentResType.type === 4" class="list-wrap audio-list">
            <div
              v-for="item in listData"
              :key="item.id"
              class="item"
              @click="detailDispatcher('audio', item)"
            >
              <div class="hb-resource-cover lr-img-scale">
                <img :src="item.poster" />
                <img class="play-icon" src="@/assets/img/play.png" />
              </div>
              <p class="name text2line">
                {{ langTransfer(item.name) }}
              </p>
            </div>
          </div>
          <div v-if="currentResType.type === 5" class="list-wrap video-list">
            <div
              v-for="item in listData"
              :key="item.id"
              class="item"
              @click="detailDispatcher('video', item)"
            >
              <div class="hb-resource-cover lr-img-scale">
                <img :src="item.poster" />
                <img class="play-icon" src="@/assets/img/play.png" />
              </div>
              <p class="name text1line">
                {{ langTransfer(item.name) }}
              </p>
            </div>
          </div>
          <pagination
            v-show="paginate.total > 0"
            :current-page="paginate.page"
            :rows="paginate.pageSize"
            :total="paginate.total"
            @handleCurrentChangeSub="onChangePagination"
          />
        </div>
      </div>
      <footer-com />
    </div>
  </bscroll-view>
</template>

<script>
import BscrollView from "@/components/bscrollView";
import FooterCom from "@/components/footerCom/footerCom";
import pagination from "@/components/common/pagination/index.vue";

import {
  recommendList,
  moreResourcesPageList,
  readingDetail,
} from "../../api/lyl";

export default {
  name: "Home",
  components: {
    FooterCom,
    BscrollView,
    pagination,
  },
  data() {
    return {
      recommendData: [],
      paginate: {
        page: 1,
        pageSize: 16,
        total: 0,
      },
      listData: [],
      updateListData: [],
    };
  },
  computed: {
    webInfo() {
      return this.$store.state.webInfo;
    },
    readingRoomResType() {
      const { readingRoomResType } = this.$store.state;
      return readingRoomResType;
    },
    currentResType() {
      const { readingRoomResType } = this;
      const { type } = this.$route.params;
      const result = readingRoomResType.find((e) => {
        return e.type === Number(type);
      });
      return result || {};
    },
    currentRecommendData() {
      const { recommendData } = this;
      const { type } = this.$route.params;
      const result = recommendData.find((e) => {
        return e.type === Number(type);
      });
      return result ? result.list : [];
    },
    currentUpdateData() {
      const { updateListData } = this;
      const { type } = this.$route.params;
      if (!updateListData.list) {
        return [];
      }
      const result = updateListData.list.find((e) => {
        return e.type === Number(type);
      });
      return result ? result.list : [];
    },
  },
  watch: {
    webInfo(newVal) {
      if (newVal.service_code) {
        this.initBindingData();
        this.recommendList();
        this.getListData();
        this.getUpdateListData();
      }
    },
  },
  methods: {
    async recommendList(params = this.$route.params) {
      try {
        const { id: unique_code } = params;
        const data = await recommendList({
          service_code: this.webInfo.service_code,
          unique_code,
          type: 1,
        });
        this.recommendData = data;
      } catch (err) {
        console.log(err);
      }
    },
    async getListData(params = this.$route.params) {
      // console.log(params.type)
      // if(params.type == 15){
      //   this.paginate.pageSize = 16
      // }
      try {
        const { id: unique_code, type } = params;
        const { page, pageSize } = this.paginate;
        const data = await moreResourcesPageList({
          service_code: this.webInfo.service_code,
          unique_code,
          type,
          page,
          pageSize,
        });
        this.listData = data.records;
        this.paginate.total = data.total;
      } catch (err) {
        console.log(err);
      }
    },
    onChangePagination(res) {
      this.paginate.page = res;
      this.getListData();
    },
    async getUpdateListData() {
      try {
        const { id: unique_code } = this.$route.params;
        const data = await readingDetail({
          service_code: this.webInfo.service_code,
          unique_code,
          type: 1,
        });
        this.updateListData = data;
      } catch (err) {
        console.log(err);
      }
    },
    initBindingData(params = this.$route.params) {
      const { type } = params;
      const pageSizeMap = {
        1: 16,
        15: 16,
        3: 16,
        5: 8,
        4: 16,
      };
      this.paginate.pageSize = pageSizeMap[type];
      this.paginate.page = 1;
      this.paginate.total = 0;
      this.listData = [];
    },
    goMagazineDetail(item) {
      const { href } = this.$router.resolve({
        name: "magazineDetail",
        params: {
          id: item.id,
        },
      });
      window.open(href, "_blank");
    },
  },
  beforeRouteUpdate(to, from, next) {
    const { bscrollObj } = this.$refs.readingRoomListBScrollView;
    if (bscrollObj) {
      bscrollObj.scrollTo(0, 0);
    }
    this.initBindingData(to.params);
    this.recommendList(to.params);
    this.getListData(to.params);
    next();
  },
  beforeRouteEnter: (to, from, next) => {
    next((vm) => {
      const { service_code } = vm.webInfo;
      if (service_code) {
        vm.initBindingData();
        vm.recommendList();
        vm.getListData();
        vm.getUpdateListData();
      }
    });
  },
};
</script>

<style scoped lang="less">
@media screen and (max-width: 10000px) {
  .hb-resource-cover {
    height: 240px;
  }
}
@media screen and (max-width: 1280px) {
  .hb-resource-cover {
    height: 206px;
  }
}
.reading-room-list {
  width: 100%;
  min-height: calc(100vh - 60px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.main-content-wrap {
  width: 1200px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-bottom: 80px;
}

.carousel-wrap {
  width: 100vw;
  min-width: 1200px;
  padding: 12px 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background: #f5f7fa;

  .el-carousel {
    width: 1200px;
    box-sizing: border-box;
  }

  .el-carousel__item {
    width: 600px;
    height: 260px;
    box-sizing: border-box;
    padding: 18px;
  }

  .swiper-content {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background: #f5f7fa;
    box-shadow: 0px 8px 18px 0px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;

    .hb-resource-cover {
      width: 168px;
      height: 224px;
      border-radius: 4px;
    }

    .infos {
      flex: 1;
      overflow: hidden;
      height: 100%;
      box-sizing: border-box;
      padding: 20px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      background: #ffffff;

      .name {
        width: 100%;
        font-size: 30px;
        font-family: AlibabaPuHuiTiB;
        color: #000000;
        line-height: 36px;
      }

      .update {
        font-size: 13px;
        font-family: AlibabaPuHuiTiM;
        color: #909399;
        line-height: 20px;
        margin: 10px 0;

        span {
          padding: 5px 10px;
          display: inline-block;
          border-radius: 15px;
          margin-left: 4px;
          color: #606266;
        }
      }

      .summary {
        width: 100%;
        height: 40px;
        font-size: 13px;
        font-family: AlibabaPuHuiTiR;
        color: #909399;
        line-height: 20px;
      }

      button {
        width: 120px;
        height: 40px;
        background: #303133;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
        border-radius: 8px;
        font-size: 14px;
        font-family: AlibabaPuHuiTiM;
        color: #ffffff;
      }
    }
  }
}

.lasted-update-wrap {
  width: 100%;
  margin-top: 30px;

  .list-wrap {
    width: 100%;
    margin: 10px 0 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;

    .item {
      width: 282px;
      height: 80px;
      overflow: hidden;
      box-sizing: border-box;
      padding: 10px 20px;
      box-shadow: 0px 1px 0px 0px #e6e6e6;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
      cursor: pointer;

      .hb-resource-cover {
        width: 45px;
        height: 60px;
        border-radius: 4px;
      }

      .index-num {
        font-size: 15px;
        font-family: AlibabaPuHuiTiM;
        color: #606266;
        line-height: 24px;
        margin: 10px;
        user-select: none;
      }

      .infos {
        flex: 1;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        user-select: none;
      }

      .name {
        width: 100%;
        margin: 10px 0 4px;
        font-size: 15px;
        font-family: AlibabaPuHuiTiM;
        color: #606266;
        line-height: 24px;
      }

      .year-issue {
        font-size: 12px;
        font-family: AlibabaPuHuiTiR;
        color: #909399;
        line-height: 12px;
      }

      &:hover {
        .index-num {
          color: #303133;
        }

        .name {
          color: #303133;
        }

        .year-issue {
          color: #606266;
        }
      }
    }
  }

  .book-list {
    .item {
      width: 384px;
      box-shadow: none;
    }
  }

  .audio-list {
    .item {
      width: 282px;
      height: 65px;
      padding: 10px 20px;

      .hb-resource-cover {
        width: 45px;
        height: 45px;
        border-radius: 8px;
      }

      .infos {
        margin: 0 10px;
      }

      .index-num {
        margin: 0;
        font-size: 13px;
        font-family: AlibabaPuHuiTiM;
        color: #909399;
        line-height: 20px;
      }

      .name {
        margin: 1px 0 0;
      }

      .play-icon {
        width: 30px;
        height: 30px;
        box-sizing: border-box;
        padding: 3px;
        background: #f5f7fa;
        border-radius: 24px;
        margin-top: 8px;
        margin-right: 3px;
      }

      &:hover {
        .play-icon {
          // background: #909399;
        }
      }
    }
  }

  .video-list {
    .item {
      width: 282px;
      height: 65px;
      padding: 10px 20px;

      .hb-resource-cover {
        width: 80px;
        height: 45px;
        border-radius: 8px;
      }

      .infos {
        margin: 0 10px;
      }

      .index-num {
        margin: 0;
        font-size: 13px;
        font-family: AlibabaPuHuiTiM;
        color: #909399;
        line-height: 20px;
      }

      .name {
        margin: 1px 0 0;
      }
    }
  }
}

.total-list-wrap {
  width: 100%;
  margin-top: 30px;

  .header {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;

    h5 {
      font-size: 18px;
      font-family: AlibabaPuHuiTiM;
      color: #303133;
      line-height: 24px;
    }

    p {
      font-size: 13px;
      font-family: AlibabaPuHuiTiM;
      color: #606266;
      line-height: 24px;
      margin-left: 4px;
    }
  }

  .list-wrap {
    width: 100%;
    min-height: 484px;
    margin: 20px 0 10px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;

    .item {
      width: 129px;
      margin-right: 24px;
      margin-bottom: 20px;

      &:nth-child(8n) {
        margin-right: 0;
      }

      &:hover {
        .name {
          color: #303133;
        }

        .year-issue {
          color: #606266;
        }
      }
    }

    .hb-resource-cover {
      width: 100%;
      height: 172px;
      border-radius: 4px;
      position: relative;
    }

    .name {
      margin: 10px 0 4px;
      font-size: 15px;
      font-family: AlibabaPuHuiTiM;
      color: #606266;
      line-height: 24px;
    }

    .year-issue {
      font-size: 12px;
      font-family: AlibabaPuHuiTiR;
      color: #909399;
      line-height: 12px;
    }
  }

  .book-list {
    min-height: 596px;
    .item {
      @media screen and (max-width: 10000px) {
        .item {
          width: 180px;
        }
      }
      @media screen and (max-width: 1280px) {
        .item {
          width: 154px;
        }
      }

      .hb-resource-cover {
      }

      &:nth-child(8n) {
        margin-right: 0;
      }

      // &:nth-child(8n) {
      //   margin-right: 24px;
      // }
    }
  }

  .audio-list {
    min-height: 374px;

    .item {
      width: 129px;

      .hb-resource-cover {
        height: 129px;
        border-radius: 8px;
      }

      .play-icon {
        width: 32px;
        height: 32px;
        position: absolute;
        bottom: 10px;
        right: 10px;
        opacity: 0;
        transition: 0.3s;
      }

      &:hover {
        .play-icon {
          opacity: 1;
        }
      }
    }
  }

  .video-list {
    min-height: 432px;

    .item {
      width: 282px;

      .hb-resource-cover {
        height: 158px;
        border-radius: 8px;
      }

      .name {
        font-size: 14px;
      }

      .play-icon {
        width: 32px;
        height: 32px;
        position: absolute;
        bottom: 10px;
        right: 10px;
        opacity: 0;
        transition: 0.3s;
      }

      &:hover {
        .play-icon {
          opacity: 1;
        }
      }

      &:nth-child(8n) {
        margin-right: 24px;
      }

      &:nth-child(4n) {
        margin-right: 0;
      }
    }
  }
}
</style>
